export default {
  login: {
    title: "Connexion",
    fields: {
      email: {
        label: "Email",
        placeholder: "exemple@mail.com"
      },
      password: {
        label: "Mot de passe",
        placeholder: "Mot de passe"
      }
    },
    rememberMe: "Se souvenir de moi",
    forgotPassword: "Mot de passe oublié ?",
    submit: "Se connecter",
    submitting: "Connexion en cours...",
    noAccount: "Pas encore inscrit ?",
    createAccount: "Créer un compte",
    errors: {
      emailRequired: "L'email est requis",
      passwordRequired: "Le mot de passe est requis",
      invalidCredentials: "Email ou mot de passe incorrect"
    }
  },
  register: {
    title: "Créer un compte",
    fields: {
      organizationName: {
        label: "Nom de l'organisation",
        placeholder: "Nom de votre entreprise"
      },
      fullName: {
        label: "Nom complet",
        placeholder: "Votre nom"
      },
      email: {
        label: "Email",
        placeholder: "exemple@mail.com"
      },
      password: {
        label: "Mot de passe",
        placeholder: "Mot de passe (min. 6 caractères)"
      },
      confirmPassword: {
        label: "Confirmer mot de passe",
        placeholder: "Confirmez le mot de passe"
      }
    },
    submit: "S'inscrire",
    submitting: "Inscription en cours...",
    hasAccount: "Déjà un compte ?",
    loginLink: "Connexion",
    errors: {
      organizationRequired: "Le nom de l'organisation est requis",
      fullNameRequired: "Le nom complet est requis",
      emailRequired: "L'email est requis",
      passwordMinLength: "Le mot de passe doit contenir au moins 6 caractères",
      passwordMismatch: "Les mots de passe ne correspondent pas",
      registrationFailed: "Erreur lors de l'inscription"
    }
  }
};
